module.exports = __webpack_public_path__ + "images/home/masters/luoyi@2x-fcef8837019a4aa85629626c9d6038e0.jpg";